<mat-card *ngIf="availableDocuments" class="documents-card">
  <mat-toolbar class="documents-toolbar">
    <span style="margin-left: 8px">{{ 'documents.titol' | translate }}</span>
  </mat-toolbar>

  <mat-card-content class="upload-section">
    <div class="upload-row">
      <mat-icon matTooltip="{{ 'documents.afegirToolTip' | translate }}" class="mat-icon">attach_file</mat-icon>
      <input
        type="file"
        accept=".jpg,.png,.doc,.docx,.pdf,.xls,.xlsx,.gif,.zip,.rar,.odt,.ods,.ppt,.pptx"
        id="file"
        name="file"
        (change)="onFileChange($event)"
        class="file-input"
      />
      <span class="file-hint">{{ 'documents.fitxerMaxHint' | translate }}</span>
    </div>
  </mat-card-content>

  <mat-progress-bar mode="indeterminate" *ngIf="showAsyncProgress"></mat-progress-bar>

  <mat-card-content>
    <ng-container *ngIf="availableDocuments.length; else noDocuments">
      <!-- Capçalera -->
      <div class="doc-header">
        <div class="col-actions">{{ 'documents.colAccions' | translate }}</div>
        <div class="col-desc">{{ 'documents.colDescripcio' | translate }}</div>
        <div class="col-nota" title="{{ 'documents.colNotaTitle' | translate }}">{{ 'documents.colNota' | translate }}</div>
        <div class="col-fitxer">{{ 'documents.colFitxer' | translate }}</div>
      </div>

      <!-- Llista de documents -->
      <div
        *ngFor="let document of availableDocuments; let i = index"
        class="doc-row"
      >
        <div class="col-actions">
          <button
            mat-icon-button
            (click)="updateDocument(i)"
            matTooltip="{{ 'documents.desarToolTip' | translate }}"
            attr.aria-label="{{ 'documents.desarToolTip' | translate }}"
            matTooltipClass="tooltip-style"
          >
            <mat-icon color="primary">save</mat-icon>
          </button>
          <button
            mat-icon-button
            (click)="deleteDocument(i)"
            matTooltip="{{ 'documents.eliminarToolTip' | translate }}"
            attr.aria-label="{{ 'documents.eliminarToolTip' | translate }}"
            matTooltipClass="tooltip-style"
          >
            <mat-icon style="color: red">delete_forever</mat-icon>
          </button>
        </div>
        <div class="col-desc">
          <mat-form-field appearance="legacy" class="col-desc">
            <input matInput [(ngModel)]="document.descripcio" placeholder="{{ 'documents.colDescripcio' | translate }}" />
          </mat-form-field>
        </div>
        <div class="col-nota">
          <mat-form-field appearance="legacy" class="col-nota">
            <input matInput [(ngModel)]="document.nota" placeholder="{{ 'documents.colNota' | translate }}" />
          </mat-form-field>
        </div>
        <div class="col-fitxer">
        <ng-container *ngIf="document.fitxer; else noFile">
          <a [href]="'/assets/documents/' + document.tipus + '/' + document.fitxer" 
          target="_blank" download="{{document.fitxer}}" class="download-link"
          matTooltip="{{ 'documents.descarregarToolTip' | translate }}"
        >
            <mat-icon style="vertical-align: middle; font-size: 18px;">insert_drive_file</mat-icon>
            {{ document.fitxer }}
          </a>
        </ng-container>

  <ng-template #noFile>
    <span style="color: #999; font-style: italic;">{{ 'documents.senseFitxer' | translate }}</span>
  </ng-template>
</div>
      </div>
    </ng-container>

    <ng-template #noDocuments>
      <p class="no-docs-msg">{{ 'documents.noDocuments' | translate }}</p>
    </ng-template>
  </mat-card-content>
</mat-card>

<!-- Error -->
<mat-card *ngIf="error" class="error-card">
  <mat-card-header>
    <mat-card-title>{{ 'documents.errorTitol' | translate:{ status: error.status } }}</mat-card-title>
    <mat-card-subtitle>{{ error.statusText }}</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <p>{{ error.msg }}</p>
  </mat-card-content>
</mat-card>
